import { createContext, FunctionComponent, useContext } from "react";
import { AuthContextProps, AuthProviderProps } from "./auth.types";

const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);

export const AuthProvider: FunctionComponent<AuthProviderProps> = ({
  children,
}) => {
  return (
    <AuthContext.Provider value={{ userInfo: {} }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
